/** Layers that own Escape while focus is inside them. */
const ESCAPE_LAYERS = '[role="dialog"], [role="alertdialog"], [role="menu"], [role="listbox"]';

/**
 * True when a global Escape listener should stand down: another layer already
 * handled the event, an input method is composing, or focus is inside an open
 * dialog, menu or list.
 * Істина, коли глобальний слухач Escape має поступитися: подію вже опрацював
 * інший шар, триває введення через IME або фокус усередині відкритого шару.
 */
export function escapeHandledElsewhere(
  event: Pick<KeyboardEvent, "defaultPrevented" | "isComposing" | "target">,
): boolean {
  if (event.defaultPrevented || event.isComposing) return true;
  return event.target instanceof Element && event.target.closest(ESCAPE_LAYERS) !== null;
}
